const NS = 'MmfsAccordionBlock';
const CLS = 'mmfsAccordionBlock';

import { mediaQuery } from '../../../../global/js/wool/mediaQuery';

export class MmfsAccordionBlock {
	constructor(element) {
		this.element = element;
		this.$element = $(element);

		this.mediaQuery = mediaQuery;

		this.renderEllipsis();
		this.renderImageMargin();

		$(window).resize(_.throttle(() => {
			this.renderEllipsis();
			this.renderImageMargin();
		}, 250));

		this.wysiwygExtract();
		this.collapsEventsListener();
	}

	renderEllipsis() {
		this.$element.find(`.${CLS}-card-header`).each((index, element) => {
			let $element = $(element);
			let $cardContent = $element.find(`.${CLS}-card-header-content`);
			let $cardTitle = $element.find(`.${CLS}-card-header-title`);
			let $imageContainerContent = $element.find(`.${CLS}-card-header-imageContainer`);
			let $cardContentCompact = $cardContent.find('[accordion-compact]');

			if($imageContainerContent && $imageContainerContent.length > 0) {
				if($cardContent.outerHeight() > $imageContainerContent.outerHeight()) {

					setTimeout(() => {
						// Hacky way of setting the max height to simulate an ellipsis…
						let targetedHeight = $imageContainerContent.height() - $cardTitle.height();
						let newPixelHeight = 0;
						let averageLineHeight = 24;
						let lineCount = 0;
						while(newPixelHeight < targetedHeight) {
							newPixelHeight += averageLineHeight;
							lineCount++;
						}
						newPixelHeight += 2; // Tweak 4px into the pixel height

						// Use multi-line css properties to add an ellipsis
						$cardContentCompact.css({
							'display': '-webkit-box',
							'-webkit-line-clamp': `${lineCount}`,
							'-webkit-box-orient': 'vertical',
							'height': `${newPixelHeight}px`,
							'overflow': 'hidden',
							'text-overflow': 'ellipsis'
						});
					}, 50);
				}
				else {
					$cardContentCompact.css({
						'display': '',
						'-webkit-line-clamp': '',
						'-webkit-box-orient': '',
						'height': '',
						'overflow': '',
						'text-overflow': ''
					});
				}
			}
		});
	}

	renderImageMargin() {
		this.$element.find(`.${CLS}-card-header`).each((index, element) => {
			let $element = $(element);
			let $cardContent = $element.find(`.${CLS}-card-header-content`);
			let $imageContainerContent = $element.find(`.${CLS}-card-header-imageContainer`);

			if($imageContainerContent && $imageContainerContent.lengtj > 0) {
				if($cardContent.outerHeight() > $imageContainerContent.outerHeight()) {
					$imageContainerContent.css({
						marginBottom: '0'
					});
				}
				else {
					$imageContainerContent.css({
						marginBottom: '1.5rem'
					});
				}
			}
		});
	}

	wysiwygExtract() {
		this.$readMoreHeader = this.$element.find(`.${CLS}-card-header[accordion-wysiwyg-extract]`);

		if(this.$readMoreHeader && this.$readMoreHeader.length > 0) {
			this.$readMoreHeader.on('click', (event) => {
				let $element = $(event.currentTarget);
				let currentReveal = $element.attr('accordion-wysiwyg-extract-reveal');
				if(currentReveal === 'true') {
					this.$readMoreHeader.attr('accordion-wysiwyg-extract-reveal', false);
				}
				else {
					this.$readMoreHeader.attr('accordion-wysiwyg-extract-reveal', false);
					$element.attr('accordion-wysiwyg-extract-reveal', true);
				}

				this.renderImageMargin();
			});
		}
	}

	collapsEventsListener() {
		this.$element.find('.collapse').on('shown.bs.collapse', (e) => {
			let $currentCollapse = $(e.currentTarget);

			if($currentCollapse.find('.slick-initialized').length > 0) {
				$currentCollapse.find('.slick-initialized').each((index, element) => {
					$(element).slick('setPosition');
					$(window).trigger('resize');
				});
			}
		});
	}
}
